import { render, staticRenderFns } from "./gb-ant-select-pagination-multiple.vue?vue&type=template&id=214e16d8&"
import script from "./gb-ant-select-pagination-multiple.vue?vue&type=script&lang=js&"
export * from "./gb-ant-select-pagination-multiple.vue?vue&type=script&lang=js&"
import style0 from "./gb-ant-select-pagination-multiple.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports